<template>
    <div class="blog-box blog-grid-box">
    <div class="blog-grid-box-img">
      <img :src="training.thumb" class="img-responsive" alt="" />
    </div>
    
    <div class="blog-grid-box-content">
      <div class="blog-avatar text-center">
        <img :src="training.authorAvatar" class="img-responsive" alt="" />
        <p><strong>{{ $t('training.author') }} </strong> <span class="theme-cl">{{ training.author }}</span></p>
      </div>
      <h4>{{ training.title }}</h4>
      <p>{{ training.content }}</p>
      <router-link :to="'/training/' + training.id" class="theme-cl" title="Read More..">{{ $t('training.more') }}</router-link>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Blog',
  props: ['training']
}
</script>